<template>
  <div class="invite-user-form">
    <label class="text-xs text-typo font-weight-bolder ms-1">Emails</label>
    <v-row v-for="(email, index) in emails" :key="index" class="mb-4">
      <v-col cols="11">
        <v-text-field
          v-model="emails[index]"
          outlined
          dense
          type="email"
          placeholder="Enter email address"
          prepend-inner-icon="mdi-email"
          class="
            font-size-input
            placeholder-lighter
            text-light-input
            border border-radius-md
            mt-2
          "
          hide-details="auto"
          width="100%"
        ></v-text-field>
      </v-col>
      <v-col cols="1" class="d-flex align-center">
        <v-btn
          v-if="emails.length > 1"
          icon
          @click="removeEmailInput(index)"
          class="mt-6"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <div class="d-flex flex-column align-end">
      <v-btn
        text
        x-small
        color="error"
        class="mb-4"
        @click="addEmailInput"
      >
        <v-icon left small>mdi-plus</v-icon>
        Add Email(s)
      </v-btn>
      <v-alert
        v-if="error"
        type="error"
        dense
        class="mb-4"
      >
        {{ error }}
      </v-alert>
      <v-alert
        v-if="success"
        type="success"
        dense
        class="mb-4"
      >
        Invitations sent successfully!
      </v-alert>
      <v-btn
        color="secondary"
        dark
        :loading="loading"
        @click="handleSendInvites"
      >
        Send Invites
      </v-btn>
    </div>
  </div>
</template>

<script>
import { sendInviteEmail } from "@/services/firebase-helpers";

export default {
  name: "InviteUser",
  props: {
    companyId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      emails: [""],
      loading: false,
      error: null,
      success: false
    };
  },
  methods: {
    addEmailInput() {
      this.emails.push("");
    },
    removeEmailInput(index) {
      this.emails.splice(index, 1);
    },
    getEmails() {
      return this.emails.filter(email => email.trim() !== "");
    },
    async handleSendInvites() {
      this.loading = true;
      this.error = null;
      this.success = false;

      const emails = this.getEmails();
      if (emails.length === 0) {
        this.error = "Please enter at least one email address";
        this.loading = false;
        return;
      }

      try {
        const results = await Promise.all(
          emails.map(email => sendInviteEmail(email, this.$store.state.auth.companyId))
        );

        const failedEmails = results.filter(result => !result.success);
        if (failedEmails.length > 0) {
          this.error = `Failed to send invites to some emails: ${failedEmails.map(r => r.message).join(', ')}`;
        } else {
          this.success = true;
          this.emails = [""];
          this.$emit('send-invites', emails);
        }
      } catch (error) {
        this.error = error.message;
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>

<style scoped>
.invite-user-form {
  width: 100%;
}
</style> 